import { useCallback, useMemo, useState } from 'react';
import {
  addFavoriteSnapshot,
  loadFavoriteSnapshots,
  resolveFavoriteGames,
} from '../lib/favorites.js';

export function useFavorites(groups, searchTerm) {
  const [stored, setStored] = useState(() => loadFavoriteSnapshots());

  const addPlayedGame = useCallback((game) => {
    if (!game?.id || !game?.url) return;
    setStored(addFavoriteSnapshot(game));
  }, []);

  const favoriteGames = useMemo(
    () => resolveFavoriteGames(stored, groups, searchTerm),
    [stored, groups, searchTerm],
  );

  return { favoriteGames, addPlayedGame };
}
